import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";


// Sprint-10 Phase A — Sentry frontend init. Must run BEFORE ReactDOM
// mounts so an exception in App's first render is captured.
//
// Gated by REACT_APP_SENTRY_DSN. CRA inlines REACT_APP_* env vars at
// build time, so the bundle is identical across environments except
// for the DSN literal. When the env var is absent the SDK is never
// imported — keeps the dev / preview bundle slim.
//
// beforeSend redacts survey tokens from URLs. A survey URL contains
// the respondent's pseudonymous identity; if an exception fires on
// /survey/:token the URL ships to Sentry unless we strip it here.
if (process.env.REACT_APP_SENTRY_DSN) {
  // Dynamic import so the bundle stays small when the SDK isn't in use.
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "development",
      release: process.env.REACT_APP_SENTRY_RELEASE || "unknown",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
      beforeSend(event) {
        // Redact survey token from request URL.
        const req = event.request;
        if (req?.url?.includes("/survey/")) {
          req.url = req.url.replace(
            /\/survey\/[a-zA-Z0-9-]+/,
            "/survey/[token]",
          );
        }
        // Same redaction on every breadcrumb that touched the survey page.
        if (Array.isArray(event.breadcrumbs)) {
          for (const b of event.breadcrumbs) {
            if (b?.data?.url?.includes("/survey/")) {
              b.data.url = b.data.url.replace(
                /\/survey\/[a-zA-Z0-9-]+/,
                "/survey/[token]",
              );
            }
          }
        }
        return event;
      },
    });
    console.info("[sentry] frontend SDK initialized");
  });
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
